export default __webpack_public_path__ + "static/trino-165953016d653cdea0df649083cee8ce.png";